import { useEffect, useState } from "react";

export function useLocalStorageWatcher(key) {
  const [value, setValue] = useState(() => {
    return localStorage.getItem(key);
  });

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === key) {
        setValue(event.newValue);
      }
    };
    window.addEventListener("storage", handleStorageChange);

    const originalSetItem = localStorage.setItem;
    const originalRemoveItem = localStorage.removeItem;

    localStorage.setItem = function (k, v) {
      originalSetItem.call(this, k, v);
      if (k === key) {
        setValue(v);
      }
    };

    localStorage.removeItem = function (k) {
      originalRemoveItem.call(this, k);
      if (k === key) {
        setValue(null);
      }
    };

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      localStorage.setItem = originalSetItem;
      localStorage.removeItem = originalRemoveItem;
    };
  }, [key]);

  return [value, setValue];
}
